import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetCanalCommunication from './met-canal-communication';
import MetCanalCommunicationDetail from './met-canal-communication-detail';
import MetCanalCommunicationUpdate from './met-canal-communication-update';
import MetCanalCommunicationDeleteDialog from './met-canal-communication-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetCanalCommunicationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetCanalCommunicationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetCanalCommunicationDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetCanalCommunication} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetCanalCommunicationDeleteDialog} />
  </>
);

export default Routes;
